import React from 'react';
import {
  FolderOpen,
  Mic,
  Film,
  FileText,
  Mail,
  Megaphone,
  Eye,
  EyeOff,
} from 'lucide-react';
import { MarketingContentType } from '../../types/marketing';
import './MarketingSidebar.css';

interface MarketingSidebarProps {
  selectedType: MarketingContentType | null;
  onSelectType: (t: MarketingContentType | null) => void;
  typeCounts: Record<string, number>;
  hideArchived: boolean;
  onToggleArchived: () => void;
}

interface SidebarItemDef {
  id: MarketingContentType | null;
  label: string;
  icon: React.ReactNode;
  enabled: boolean;
}

const ITEMS: SidebarItemDef[] = [
  { id: null,             label: 'All Content',     icon: <FolderOpen size={15} />, enabled: true  },
  { id: 'podcast-video',  label: 'Podcast Videos',  icon: <Mic size={15} />,        enabled: true  },
  { id: 'reel',           label: 'Reels',           icon: <Film size={15} />,       enabled: false },
  { id: 'blog',           label: 'Blog Posts',      icon: <FileText size={15} />,   enabled: false },
  { id: 'email-blast',    label: 'Email Blasts',    icon: <Mail size={15} />,       enabled: false },
  { id: 'ad',             label: 'Ads',             icon: <Megaphone size={15} />,  enabled: false },
];

const MarketingSidebar: React.FC<MarketingSidebarProps> = ({
  selectedType,
  onSelectType,
  typeCounts,
  hideArchived,
  onToggleArchived,
}) => {
  return (
    <aside className="mh-sidebar">
      <div className="mh-sidebar-header">
        <span className="mh-sidebar-label">Marketing</span>
      </div>

      <nav className="mh-sidebar-nav">
        {ITEMS.map(item => {
          const isActive = item.id === selectedType;
          const count =
            item.id === null ? typeCounts.all : typeCounts[item.id] || 0;
          const disabled = !item.enabled;
          return (
            <button
              key={item.id ?? 'all'}
              className={`mh-sidebar-item ${isActive ? 'active' : ''} ${disabled ? 'disabled' : ''}`}
              onClick={() => !disabled && onSelectType(item.id)}
              disabled={disabled}
              aria-pressed={isActive}
              title={disabled ? 'Coming soon' : undefined}
            >
              <span className="mh-sidebar-item-icon">{item.icon}</span>
              <span className="mh-sidebar-item-label">{item.label}</span>
              {disabled ? (
                <span className="mh-sidebar-item-soon">Soon</span>
              ) : (
                count > 0 && <span className="mh-sidebar-item-count">{count}</span>
              )}
            </button>
          );
        })}
      </nav>

      <button
        className={`mh-sidebar-toggle-archived ${!hideArchived ? 'showing' : ''}`}
        onClick={onToggleArchived}
      >
        {hideArchived ? <Eye size={13} /> : <EyeOff size={13} />}
        <span>{hideArchived ? 'Show archived' : 'Hide archived'}</span>
      </button>
    </aside>
  );
};

export default MarketingSidebar;
